module.exports = __webpack_public_path__ + "media/assets/images/flags/am-7c1d73cf66ec85b71f9bb39580b8ca40.svg";